"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m10 4.432.672 1.421a.7.7 0 1 0 1.266-.598l-.693-1.466c-.498-1.052-1.992-1.052-2.49 0l-1.42 3.006-3.138.416c-1.108.146-1.586 1.482-.831 2.3l1.897 2.06a.7.7 0 1 0 1.03-.948l-1.87-2.03 3.473-.46a.7.7 0 0 0 .541-.395zm4.578 3.322a.7.7 0 0 1 .786-.602l.44.059c1.108.146 1.585 1.482.83 2.3l-2.292 2.49.627 3.366c.208 1.118-.952 2-1.973 1.484L10 15.341l-2.996 1.51a.7.7 0 1 1-.63-1.25l3.31-1.67a.7.7 0 0 1 .631 0l3.27 1.649-.683-3.668a.7.7 0 0 1 .173-.602l2.503-2.717-.398-.053a.7.7 0 0 1-.602-.786m1.917-4.249a.7.7 0 0 1 0 .99l-12 12a.7.7 0 0 1-.99-.99l12-12a.7.7 0 0 1 .99 0",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=NoStarIcon20.js.map